import { ObservableArray, View } from "binder"
import { DistinguishingDetailValueUpdaterViewModel, singleValue } from "./distinguishingDetailValueUpdater-viewModel"

export class DistinguishingDetailValueUpdaterView extends View<DistinguishingDetailValueUpdaterViewModel>{
    GetViewUniqueId(): string {
        return "V-BA7EBA5F-7E47-431C-B55E-6B8FBDB69C71"
    }
    loadHtml(): string {
        let element = require('./distinguishingDetailValueUpdater.html').default;
        let style = require('./distinguishingDetailValueUpdater.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set values(v: ObservableArray<singleValue>) { this._values = v; } public get values(): ObservableArray<singleValue> { return this._values;} private _values: ObservableArray<singleValue>;
    
    confirm(){
        this.dataContext.confirm();
    }
    cancel(){
        this.dataContext.cancel();
    }

    addNew(){
        this.dataContext.addNew();
    }
}
